import { getGuideTourStepRoute } from '../routing/utils'
import type { GuideTourRouteQueueInfo } from '../routing/queue'
import { getCurrentGuideTourStep } from '../state'
import type { GuideTourRuntimeState } from '../types'
import {
  countAvailableGuideTourSteps,
  getAvailableGuideTourStepNumber,
} from '../utils/tourRuntime'
import type { GuideTourTrackingSnapshot } from './types'

export const buildGuideTourTrackingSnapshot = (
  runtimeState: GuideTourRuntimeState,
  pathname: string,
  routeQueueInfo?: GuideTourRouteQueueInfo
): GuideTourTrackingSnapshot | null => {
  if (runtimeState.status !== 'active' || !runtimeState.activeTour) {
    return null
  }

  const tour = runtimeState.activeTour
  const step = getCurrentGuideTourStep(runtimeState)

  return {
    currentStep: getAvailableGuideTourStepNumber(
      tour,
      runtimeState.currentStepIndex
    ),
    totalStep: countAvailableGuideTourSteps(tour),
    ...(routeQueueInfo
      ? {
          tourCurrent: routeQueueInfo.position,
          tourTotal: routeQueueInfo.total,
        }
      : {}),
    pathname,
    route:
      (step && getGuideTourStepRoute(tour, step)) ?? tour.route ?? pathname,
    tour,
    step: step ?? undefined,
  }
}
